import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { ChannelsSubList } from './ChannelsSubList';
import { CollapsableSection } from './CollapsableSection';
import { VoiceRecording } from './VoiceRecording';
export const AlertVoiceMessage = ({ data }) => {
    var _a, _b, _c;
    const { t } = useAlertUiTranslation();
    const upMdScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));
    if ((_a = data.channels) === null || _a === void 0 ? void 0 : _a.includes('voice')) {
        return (React.createElement(CollapsableSection, { title: upMdScreen ? (t('common.voiceMessage')) : (React.createElement(React.Fragment, null,
                t('common.voiceMessage'),
                " ",
                React.createElement(ChannelsSubList, { data: data, filterChannels: ['voice'] }))), header: React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                upMdScreen && React.createElement(ChannelsSubList, { data: data, filterChannels: ['voice'] }),
                React.createElement(Box, { sx: { flexGrow: 1 } }),
                React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: 1 } },
                    data.voiceMessageType === 'textToVoice' && React.createElement(Chip, { size: 'small', label: t('common.convertTextToVoice') }),
                    data.voiceMessageType === 'record' && React.createElement(Chip, { size: 'small', label: t('common.record') }),
                    ((_b = data.settings) === null || _b === void 0 ? void 0 : _b.voiceRepeatCount) != null && (React.createElement(Chip, { size: 'small', label: t('common.repeatCount', { count: data.settings.voiceRepeatCount }) })),
                    ((_c = data.settings) === null || _c === void 0 ? void 0 : _c.voiceRepeatDelay) != null && (React.createElement(Chip, { size: 'small', label: t('common.timeBetweenCalls', { count: data.settings.voiceRepeatDelay }) })))) },
            data.voiceMessageType === 'textToVoice' && (React.createElement(Typography, { component: 'div', variant: 'body2', sx: {
                    p: 2,
                    whiteSpace: 'pre-wrap',
                } }, data.voiceMessage)),
            data.voiceMessageType === 'record' && data.voiceRecordings && data.voiceRecordings.length > 0 && (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, backgroundColor: themeColors.surface.secondary } }, data.voiceRecordings.map((recording) => (React.createElement(Box, { key: recording.id, sx: {
                    p: 2,
                    backgroundColor: themeColors.surface.tertiary,
                    borderRadius: 1,
                    '& audio': {
                        backgroundColor: themeColors.surface.secondary,
                    },
                } },
                React.createElement(Typography, { variant: 'subtitle2', sx: { mb: 2 } }, t(`enum.voiceRecordingType.${recording.type}`)),
                React.createElement(VoiceRecording, { id: recording.id }))))))));
    }
    else {
        return null;
    }
};
